import { createSlice } from '@reduxjs/toolkit'

export const cartSlice = createSlice({
  name: 'cart',
  initialState: Object.assign(
    {
      cart: null,
      open: false,
      upsells: [],
      bumpVariant: null,
      bagoVariant: null,
      bogoVariants: [],
    },
    localStorage.getItem('app_state') ? JSON.parse(localStorage.getItem('app_state')) : {},
  ),
  reducers: {
    setCart: (state, action) => {
      state.cart = action.payload
      localStorage.setItem('app_state', JSON.stringify(state))
    },
    cartOpen: (state, action) => {
      state.open = action.payload
      localStorage.setItem('app_state', JSON.stringify(state))
    },
    setUpsells: (state, action) => {
      state.upsells = action.payload
      localStorage.setItem('app_state', JSON.stringify(state))
    },
    setBumpVariant: (state, action) => {
      state.bumpVariant = action.payload
      localStorage.setItem('app_state', JSON.stringify(state))
    },
    setBagoVariant: (state, action) => {
      state.bagoVariant = action.payload
      localStorage.setItem('app_state', JSON.stringify(state))
    },
    setBogoVariants: (state, action) => {
      state.bogoVariants = action.payload
      localStorage.setItem('app_state', JSON.stringify(state))
    },
  },
})

export const { setCart, cartOpen, setUpsells, setBumpVariant, setBagoVariant, setBogoVariants } = cartSlice.actions

export default cartSlice.reducer
